import React, { useState, useMemo } from 'react';
import Slider from "react-slick";

export function GalleryWidget({configuration}) {
  return (
    <Slider {...configuration.settings}>
      {configuration.images.map((url, idx) =>
          <div key={`image-${idx}`} className="pe-1">
            <img src={url} alt="img" className="img-fluid rounded" />
          </div>
      )}
    </Slider>
  );
}
